// extracted by mini-css-extract-plugin
module.exports = {"page-box":"item_page-box__2C28w","feature-box":"item_feature-box__2DS9u","save-button":"item_save-button__2xXt3","del-button":"item_del-button___52tS"};